import type CartsV2 from 'bundles/naptimejs/resources/carts.v2';
// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import type SubscriptionNextBillDetailsV1 from 'bundles/naptimejs/resources/subscriptionNextBillDetails.v1';

export const isNextBillingCycleDiscounted = (
  cart?: CartsV2,
  subscriptionNextBillDetails?: SubscriptionNextBillDetailsV1
): boolean => {
  if (cart && subscriptionNextBillDetails) {
    return cart.originalTotalAmount > parseFloat(subscriptionNextBillDetails.nextBillingPeriodAmount);
  } else {
    return false;
  }
};
